export default "__VITE_PUBLIC_ASSET__75d0dfb6__"